export const SEMESTERS_LOAD = 'SEMESTERS_LOAD'
export const SEMESTERS_LOAD_FULFILLED = 'SEMESTERS_LOAD_FULFILLED'
export const SEMESTERS_LOAD_REJECTED = 'SEMESTERS_LOAD_REJECTED'

export const SEMESTERS_ELEMENTS_LOAD = 'SEMESTERS_ELEMENTS_LOAD'
export const SEMESTERS_ELEMENTS_LOAD_FULFILLED =
  'SEMESTERS_ELEMENTS_LOAD_FULFILLED'
export const SEMESTERS_ELEMENTS_LOAD_REJECTED =
  'SEMESTERS_ELEMENTS_LOAD_REJECTED'
